import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { GameDetailsPage } from './pages/GameDetailsPage';
import { SearchResults } from './pages/SearchResults';
import { TrendingPage } from './pages/TrendingPage';
import { UserProfilePage } from './pages/UserProfilePage';
import { UserAchievementsPage } from './pages/UserAchievementsPage';
import { GameAchievementsPage } from './pages/GameAchievementsPage';
import { UserFriendsPage } from './pages/UserFriendsPage';
import { UserBadgesPage } from './pages/UserBadgesPage';
import { ErrorBoundary } from './components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/game/:id" element={<GameDetailsPage />} />
              <Route path="/trending" element={<TrendingPage />} />
              <Route path="/user/:username" element={<UserProfilePage />} />
              <Route path="/user/:username/achievements" element={<UserAchievementsPage />} />
              <Route path="/user/:username/game/:appid/achievements" element={<GameAchievementsPage />} />
              <Route path="/user/:username/friends" element={<UserFriendsPage />} />
              <Route path="/user/:username/badges" element={<UserBadgesPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ErrorBoundary>
  );
}